module.exports = " <div> <relate-fieldtype v-ref:relate :data.sync=data :name=name :config=config> </relate-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/AdaptsRelateFieldtype.vue
// module id = 671
// module chunks = 0